/**
 * Russian defaults for Zod.
 *
 * Every schema in the app supplies its own message, so this map should never be
 * reached in normal use. It exists because Zod's built-in fallbacks are English
 * ("Required", "Invalid email") and a single unhandled issue code would put an
 * English string in front of a Russian-speaking trader.
 */

import { ZodIssueCode, z, type ZodErrorMap } from 'zod';

const errorMap: ZodErrorMap = (issue, context) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      return {
        message: issue.received === 'undefined' ? 'Заполните это поле.' : 'Некорректное значение.',
      };
    case ZodIssueCode.invalid_string:
      return { message: issue.validation === 'email' ? 'Некорректный адрес почты.' : 'Некорректный формат.' };
    case ZodIssueCode.too_small:
      return { message: 'Значение слишком короткое.' };
    case ZodIssueCode.too_big:
      return { message: 'Значение слишком длинное.' };
    default:
      return { message: context.defaultError === 'Required' ? 'Заполните это поле.' : 'Некорректное значение.' };
  }
};

export function installZodRussianErrors(): void {
  z.setErrorMap(errorMap);
}
